import { CSSProperties } from 'react';
import Colors from 'modules/Colors';
import Icon from './Icon';

export interface BrandInfoProps {
  className?: string;
  style?: CSSProperties;
  brandName: string;
  brandImage?: string;
  brandSlug?: string;
  variant?: 'default' | 'small';
  titleColor?: string;
  imageSize?: number;
  showSlug?: boolean;
}

const BrandInfo = ({
  className,
  style,
  brandName,
  brandImage,
  brandSlug,
  variant = 'default',
  titleColor,
  imageSize,
  showSlug = true,
}: BrandInfoProps) => {
  const isSmall = variant === 'small';
  
  const defaultImageSize = isSmall ? 24 : 40;
  const actualImageSize = imageSize || defaultImageSize;
  
  const sty: Record<string, CSSProperties> = {
    brandInfo: {
      display: 'flex',
      alignItems: 'center',
      gap: isSmall ? 8 : 12,
    },
    brandImage: {
      width: actualImageSize,
      height: actualImageSize,
      borderRadius: isSmall ? '50%' : 8,
      objectFit: 'cover',
    },
    brandIconPlaceholder: {
      width: actualImageSize,
      height: actualImageSize,
      borderRadius: isSmall ? '50%' : 8,
      backgroundColor: Colors.greyLight,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    brandTitleContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: isSmall ? 0 : 2,
    },
    brandName: {
      fontSize: isSmall ? 12 : 16,
      fontWeight: isSmall ? 400 : 600,
      color: titleColor || Colors.white,
    },
    brandSlug: {
      fontSize: isSmall ? 10 : 12,
      color: Colors.greyDark,
    },
  };

  return (
    <div 
      className={className || 'brandInfo'} 
      style={{
        ...sty.brandInfo,
        ...style
      }}
    >
      {brandImage ? (
        <img
          className="brandImage"
          src={brandImage}
          alt={brandName}
          style={sty.brandImage}
        />
      ) : (
        <div className="brandIconPlaceholder" style={sty.brandIconPlaceholder}>
          <Icon
            className="brandDefaultIcon"
            icon="user"
            size={isSmall ? 12 : 20}
            color={Colors.greyDark}
          />
        </div>
      )}
      <div className="brandTitleContainer" style={sty.brandTitleContainer}>
        <div className="brandName" style={sty.brandName}>
          {brandName}
        </div>
        {brandSlug && showSlug && (
          <div className="brandSlug" style={sty.brandSlug}>
            @{brandSlug}
          </div>
        )}
      </div>
    </div>
  );
};

export default BrandInfo;
